/**
 * Centralised app configuration.
 * When you connect a custom domain, change REACT_APP_BASE_URL in .env
 * and every page, sitemap reference, and JSON-LD schema picks it up.
 */
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://www.weguide.health";
